import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchprojects = async (lang) => {
  const response = await axios.get(`${API_URL}/api/projects/projects`, {
    params: { lang },
  });
  return response.data;
};
export const fetchProject = async (lang, slug) => {
  const response = await axios.get(`${API_URL}/api/projects/projects/${slug}`, {
    params: { lang },
  });
  return response.data;
};

export const fetchTeams = async (lang) => {
  const response = await axios.get(`${API_URL}/api/team/teams`, {
    params: { lang },
  });
  return response.data;
};
export const fetchTeam = async (lang, slug) => {
  const response = await axios.get(`${API_URL}/api/team/teams/${slug}`, {
    params: { lang },
  });
  return response.data;
};
export const fetchBlogs = async (lang) => {
  const response = await axios.get(`${API_URL}/api/articles/posts`, {
    params: { lang },
  });
  return response.data;
};

export const fetchBlog = async (lang, slug) => {
  const response = await axios.get(
    `${API_URL}/api/articles/posts/${slug}`,
    { params: { lang } }
  );
  return response.data;
};

export const fetchContact = async (lang) => {
  const response = await axios.get(`${API_URL}/api/contact`, {
    params: { lang },
  });
  return response.data;
};
export const fetchPricing = async (lang) => {
  const response = await axios.get(`${API_URL}/api/pricing/pricing`, {
    params: { lang },
  });
  return response.data;
};
export const fetchBrands = async (lang) => {
  const response = await axios.get(`${API_URL}/api/logo/brands`, {
    params: { lang },
  });
  return response.data;
};

export const fetchTestimonials = async (lang) => {
  const response = await axios.get(`${API_URL}/api/testimonials/testimonials`, {
    params: { lang },
  });
  return response.data;
};

export const fetchFAQ = async (lang) => {
  const response = await axios.get(`${API_URL}/api/faqs`, {
    params: { lang },
  });
  return response.data;
};

export const fetchServices = async (lang) => {
  const response = await axios.get(`${API_URL}/api/services/services`, {
    params: { lang },
  });
  return response.data;
};
export const fetchService = async (lang, slug) => {
  const response = await axios.get(`${API_URL}/api/services/services/${slug}`, {
    params: { lang },
  });
  return response.data;
};
export const fetchPrivacy = async (lang) => {
  const response = await axios.get(`${API_URL}/api/privacy`, {
    params: { lang },
  });
  return response.data;
};

export const fetchTerms = async (lang) => {
  const response = await axios.get(`${API_URL}/api/terms`, {
    params: { lang },
  });
  return response.data;
};
